import React from 'react';
import BackButton from '@/components/BackButton';

const Changelog: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Changelog</h1>

          <div className="space-y-12">
            <div>
              <h2>Version 1.2.0 (March 2024)</h2>
              <ul>
                <li>Added new social media templates</li>
                <li>Enhanced Telegram notification system</li>
                <li>Improved mobile responsiveness</li>
                <li>Added dark mode support</li>
                <li>Security enhancements and bug fixes</li>
              </ul>
            </div>

            <div>
              <h2>Version 1.1.0 (February 2024)</h2>
              <ul>
                <li>Introduced template customization options</li>
                <li>Added data export functionality</li>
                <li>Improved error handling</li>
                <li>Updated documentation</li>
              </ul>
            </div>

            <div>
              <h2>Version 1.0.0 (January 2024)</h2>
              <ul>
                <li>Initial release</li>
                <li>Basic template library</li>
                <li>Telegram integration</li>
                <li>User authentication system</li>
                <li>Basic reporting features</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Changelog;